import React      from "react";
import List       from "../components/list";
import ListItem   from "../components/list-item";
import TimeExt   from "../components/time-ext";
import Spinner    from "../components/spinner";
import View       from "./view";
import messages   from "../../../messages";
import config     from "../../../config";
import { POINT_TYPE_FREE } from "../../../point-types";
import Tag from "../components/tag";

export default class TimeView extends View {
    static get title () {
        return "выберите удобное время приема";
    }

    static get titleShort() {
        return "время";
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            scheduleScroll: React.PropTypes.number.isRequired,
            clinic: React.PropTypes.number.isRequired,
            openWithoutDoctor: React.PropTypes.number.isRequired,
        });
    }

    constructor(props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null,
            doctor: !!this.props.doctor ? this.props.doctor : '',
            clinic: !!this.props.clinic ? this.props.clinic : '',
        });

        this._isMounted = false;
    }
    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    fetchData() {
        this.hideErrorMessage();
        this.setState({
            items: null,
        });

        let url = `${config.dataUrl}api.php?function=schedule`  +
            `&clinic=${this.props.clinic}` +
            `&service=${this.props.service}` +
            `&length=${config.scheduleLength}` +
            `&scroll=${this.props.scheduleScroll}`;
        url += this.props.openWithoutDoctor ?  '' : `&doctor=${this.state.doctor}` ;

        fetch(url).then((response) => {
            return response.json();
        }).then((responseJson) => {
            console.log('responseJson',responseJson)
            if (this._isMounted === true) {
                const dates = responseJson.dates;
                const columnIndex = dates.indexOf(this.props.date);

                if (columnIndex === -1) {
                    throw new ReferenceError("Дата не найдена.");
                }

                const column = responseJson.grid[columnIndex];
                this.setState({
                    items: column,
                });
            }
        }).catch((error) => {
            console.log(error)
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    componentDidMount() {
        this.fetchData();
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchData();
    }

    renderContent() {
        const colors = this.context.muiTheme.palette;

        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner />;
        }
        const doctorsCount = this.state.items.reduce((acc,item, key) => {
            if (!!item.doctor) acc.push(item.doctor)
            return acc
        },[])
        let docSet = new Set(doctorsCount);

        const showDoc = (!!!this.props.doctor && !(docSet.size === 1 && this.props.openWithoutDoctor))
        const elements = this.state.items.map((item, key) => {
            if (item.status === POINT_TYPE_FREE) {
                let nextView = "ContactsView";
                let propsView = {
                    time: item.time,
                    doctor: !!this.props.doctor ? this.props.doctor : item.doctor,
                    clinic: !!this.props.clinic ? this.props.clinic : item.clinic,
                };

                return (
                    <ListItem
                        key={key}
                        isActive={true}
                        hasStatusIndicator={true}
                        onClick={() => this.props.gotoNextView({
                            breadcrumbName: item.time,
                            nextView: nextView ,
                            props: propsView
                        })}>
                        <div className="appointment-time_point">
                            <div className="appointment-time_point--column">
                                <div className="appointment-time_point--item appointment-time_point--item appointment-time_point--item__time">{item.time}</div>
                            </div>
                            {showDoc && item.doctor_info.photoUrl !== null ? <div className="appointment-doctor__photo">
                                <div
                                    className="appointment-doctor__photo-image"
                                    style={{backgroundImage: `url(${item.doctor_info.photoUrl})`,
                                            height:'3em',
                                            width:'3em',
                                            marginRight: '1em'
                                    }}/>

                            </div> : null}
                            <div className="appointment-time_point--column">
                                {showDoc&&<div><div className="appointment-time_point--item appointment-time_point--item__doctor">{item.doctor_info.name}</div>
                                    <Tag key="price" style={{margin: ".2em 0;"}} text={`стоимость ${item.doctor_info.price}₽`} color={colors.accent3color} />
                                </div>}
                                {!!!this.props.clinic&&<div className="appointment-time_point--item appointment-time_point--item__clinic">{item.clinic_info.address}</div>}
                            </div>
                        </div>
                    </ListItem>
                );
            } else {
                return null;
            }
        });
        if (!!this.state.doctor){
            this.state.items.filter((item, key) => item.id === this.state.doctor)

        }


        return <List>{elements}</List>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--time">
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/time.js
 **/